var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9641 38.3906L22.3213 38.3906",
    stroke: "#1552E8",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 13.5391H32.5001C39.5834 13.5391 40.2917 16.8516 40.7709 20.8932L42.6459 36.5182C43.2501 41.6432 41.6667 45.8307 34.3751 45.8307H15.6459C8.33339 45.8307 6.75005 41.6432 7.37505 36.5182L9.25007 20.8932C9.7084 16.8516 10.4167 13.5391 17.5001 13.5391Z",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 16.6641V9.3724C16.666 6.2474 18.7493 4.16406 21.8743 4.16406H28.1243C31.2494 4.16406 33.3327 6.2474 33.3327 9.3724V16.6641",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9642 36.6094L14.2856 36.6094",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 25.8984C31.25 26.3984 31.1875 26.8828 31.0625 27.3516C30.9219 27.9766 30.6719 28.5859 30.3438 29.1172C29.2656 30.9297 27.2813 32.1484 25 32.1484C23.3906 32.1484 21.9375 31.539 20.8437 30.539C20.375 30.1328 19.9687 29.6484 19.6562 29.1172C19.0781 28.1797 18.75 27.0703 18.75 25.8984C18.75 24.2109 19.4219 22.6641 20.5156 21.5391C21.6563 20.3672 23.25 19.6484 25 19.6484C26.8438 19.6484 28.5156 20.4453 29.6406 21.7266C30.6406 22.836 31.25 24.3047 31.25 25.8984Z",
    fill: "#A020FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3315 25.8672H22.6753",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0039 23.5781V28.25",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon-9.ffee689bac947c2bdbf812ca1cda8208.svg";
export { ForwardRef as ReactComponent };